import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

import { AccountService } from 'app/core';
import { Role } from 'app/core/models/role';
import { User, Invitation } from 'app/core/models/user.types';
import { RoleService } from './roles-permissions/services/roles.service';
import { LegacyTasksTabService } from '@shared/modules/legacy-tasks/services/tasks.service';
import { Task } from 'app/shared/modules/legacy-tasks/tasks.types';

@Injectable({
  providedIn: 'root',
})
export class SettingsUsersResolver {
  constructor(private _accountService: AccountService) {}

  resolve(): Observable<User[]> {
    return this._accountService.getUsers();
  }
}

@Injectable({
  providedIn: 'root',
})
export class SettingsInvitationsResolver {
  constructor(private _accountService: AccountService) {}

  resolve(): Observable<Invitation[]> {
    return this._accountService.getInvitations();
  }
}

@Injectable()
export class SettingsRolesResolver {
  get currentAccountId(): number {
    return Number(this._accountService.getCurrentAccount().id);
  }

  constructor(
    private readonly _accountService: AccountService,
    private readonly _roleService: RoleService,
  ) {}

  resolve(): Observable<Role[]> {
    return this._roleService.getByAccountId(this.currentAccountId);
  }
}

@Injectable({
  providedIn: 'root',
})
export class TaskListTemplateTaskResolver {
  constructor(
    private readonly router: Router,
    private readonly tasksService: LegacyTasksTabService,
    private readonly accountService: AccountService,
  ) {}

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<Task> {
    this.accountService.currentAccount.subscribe((accountData) => {
      this.tasksService.accountId = accountData.id;
    });

    if (/\/settings\/task-lists/g.test(state.url)) {
      this.tasksService.isGlobalTasks = true;
    }

    return this.tasksService.getTaskById(route.paramMap.get('task_id'), +route.paramMap.get('id')).pipe(
      catchError((error) => {
        const parentUrl = state.url.split('/').slice(0, -1).join('/');
        this.router.navigateByUrl(parentUrl);
        return throwError(() => new Error(error));
      }),
    );
  }
}
